__turbopack_context__.v({
  "acciones": "adscripcionFilas-module__9b_noG__acciones",
  "ayuda": "adscripcionFilas-module__9b_noG__ayuda",
  "bloque": "adscripcionFilas-module__9b_noG__bloque",
  "bloqueAcciones": "adscripcionFilas-module__9b_noG__bloqueAcciones",
  "bloqueCampos": "adscripcionFilas-module__9b_noG__bloqueCampos",
  "contador": "adscripcionFilas-module__9b_noG__contador",
  "contadorExcedido": "adscripcionFilas-module__9b_noG__contadorExcedido",
  "entraBloque": "adscripcionFilas-module__9b_noG__entraBloque",
  "estado": "adscripcionFilas-module__9b_noG__estado",
  "estadoEra": "adscripcionFilas-module__9b_noG__estadoEra",
  "estadoNueva": "adscripcionFilas-module__9b_noG__estadoNueva",
  "estadoQuita": "adscripcionFilas-module__9b_noG__estadoQuita",
  "etiqueta": "adscripcionFilas-module__9b_noG__etiqueta",
  "etiquetaEra": "adscripcionFilas-module__9b_noG__etiquetaEra",
  "etiquetaNueva": "adscripcionFilas-module__9b_noG__etiquetaNueva",
  "etiquetaPrincipal": "adscripcionFilas-module__9b_noG__etiquetaPrincipal",
  "etiquetaQuita": "adscripcionFilas-module__9b_noG__etiquetaQuita",
  "etiquetas": "adscripcionFilas-module__9b_noG__etiquetas",
  "fila": "adscripcionFilas-module__9b_noG__fila",
  "filaAgregar": "adscripcionFilas-module__9b_noG__filaAgregar",
  "filaConMotivo": "adscripcionFilas-module__9b_noG__filaConMotivo",
  "filaEditandoNombre": "adscripcionFilas-module__9b_noG__filaEditandoNombre",
  "filaExpandida": "adscripcionFilas-module__9b_noG__filaExpandida",
  "lista": "adscripcionFilas-module__9b_noG__lista",
  "meta": "adscripcionFilas-module__9b_noG__meta",
  "motivoFila": "adscripcionFilas-module__9b_noG__motivoFila",
  "motivoTexto": "adscripcionFilas-module__9b_noG__motivoTexto",
  "nombre": "adscripcionFilas-module__9b_noG__nombre",
  "nombreOtra": "adscripcionFilas-module__9b_noG__nombreOtra",
  "nombreOtraBtn": "adscripcionFilas-module__9b_noG__nombreOtraBtn",
  "nombreOtraFila": "adscripcionFilas-module__9b_noG__nombreOtraFila",
  "nombreOtraSolo": "adscripcionFilas-module__9b_noG__nombreOtraSolo",
  "obligatorio": "adscripcionFilas-module__9b_noG__obligatorio",
  "orden": "adscripcionFilas-module__9b_noG__orden",
  "separador": "adscripcionFilas-module__9b_noG__separador",
  "tachado": "adscripcionFilas-module__9b_noG__tachado",
});
